import { Labels } from '../../shared-components/global/labels';

Labels.set(
    'ui-autocomplete',
    'hint',
    'Use up and down arrows to review and enter to select.'
);
Labels.set('ui-autocomplete', 'suggestions', 'Suggestions');
Labels.set('ui-autocomplete', 'suggestionsFound', 'Suggestions displayed: ');
Labels.set('ui-autocomplete', 'noSuggestionsFound', 'No suggestions displayed');
